import { isReadOnlyPaymentType } from '../../functions/payments'
import { ClosurePayment } from '../../util/register-closure-types'

export const getTotalCounted = (payment: ClosurePayment) => {
  if (payment.isSystemPaymentType || isReadOnlyPaymentType(payment)) {
    return payment.total
  }

  if (payment.totalCounted === undefined && parseFloat(payment.total) === 0.0) {
    return '0.00'
  }

  return payment.totalCounted
}
